import { render } from "./so-dien-thoai.vue?vue&type=template&id=4846f980"
import script from "./so-dien-thoai.vue?vue&type=script&lang=js"
export * from "./so-dien-thoai.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__